var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { rgba } from 'polished';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Icon from '@datashop/icon';
import OutsideClick from '@datashop/outside-click';
import { styledComponents } from '@datashop/theme';
import Body from './body';
import Footer from './footer';
import Header from './header';
var styled = styledComponents.default;
var Dimensions = {
    regular: 480,
    medium: 640,
    large: 800,
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  left: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  z-index: 2147483646;\n  overflow: auto;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  background-color: ",
    ";\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  left: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  z-index: 2147483646;\n  overflow: auto;\n  flex-direction: column;\n  justify-content: center;\n"])), function (props) {
    return rgba(props.theme.datashop.palette.black.main, 0.4);
});
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 4px;\n  background-color: ", ";\n  box-shadow: ", ";\n  position: relative;\n  width: ", ";\n  max-height: 80%;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n"], ["\n  border-radius: 4px;\n  background-color: ", ";\n  box-shadow: ",
    ";\n  position: relative;\n  width: ", ";\n  max-height: 80%;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n"])), function (props) { return props.theme.datashop.palette.white.main; }, function (props) {
    return "0 0 1px 0 " + rgba(props.theme.datashop.palette.black.main, 0.12) + ", 0 4px 12px 0 " + rgba(props.theme.datashop.palette.black.main, 0.16);
}, function (props) { return Dimensions[props.dimension] + "px"; });
var StyledOutsideClick = styled(OutsideClick)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  display: flex;\n"], ["\n  justify-content: center;\n  align-items: center;\n  display: flex;\n"])));
var CloseIcon = styled(Icon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  font-size: 18px;\n  top: 16px;\n  right: 16px;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  font-size: 18px;\n  top: 16px;\n  right: 16px;\n"])));
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.savedBodyOverflow = null;
        _this.activeEvent = false;
        _this.disableBodyScroll = function () {
            if (_this.savedBodyOverflow) {
                return;
            }
            _this.savedBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        };
        _this.enableBodyScroll = function () {
            document.body.style.overflow = _this.savedBodyOverflow || 'auto';
        };
        _this.setup = function (props) {
            if (props === void 0) { props = _this.props; }
            if (props.closeOnEscape && !_this.activeEvent) {
                document.addEventListener('keydown', _this.handleEscape);
                _this.activeEvent = true;
            }
            _this.disableBodyScroll();
        };
        _this.teardown = function () {
            if (_this.activeEvent) {
                document.removeEventListener('keydown', _this.handleEscape);
                _this.activeEvent = false;
            }
            _this.enableBodyScroll();
        };
        _this.handleEscape = function (event) {
            if (event.keyCode !== 27) {
                return;
            }
            _this.props.onClose();
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        this.setup();
    };
    Modal.prototype.componentWillReceiveProps = function (nextProps) {
        this.setup(nextProps);
    };
    Modal.prototype.componentWillUnmount = function () {
        this.teardown();
    };
    Modal.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, backdrop = _a.backdrop, dimension = _a.dimension, showCloseButton = _a.showCloseButton, __ = _a.closeOnEscape, children = _a.children, containerStyle = _a.containerStyle, rest = __rest(_a, ["onClose", "backdrop", "dimension", "showCloseButton", "closeOnEscape", "children", "containerStyle"]);
        if (!open) {
            return null;
        }
        var wrapperElement = (React.createElement(Wrapper, __assign({}, rest, { dimension: dimension || 'regular' }),
            children,
            showCloseButton && React.createElement(CloseIcon, { onClick: onClose, name: "close" })));
        if (backdrop) {
            wrapperElement = (React.createElement(StyledOutsideClick, { onOutsideClick: onClose }, wrapperElement));
        }
        return ReactDOM.createPortal(React.createElement(Container, { style: containerStyle }, wrapperElement), document.body);
    };
    Modal.defaultProps = {
        backdrop: true,
        showCloseButton: true,
        closeOnEscape: true,
        dimension: 'regular',
    };
    Modal.Header = Header;
    Modal.Body = Body;
    Modal.Footer = Footer;
    return Modal;
}(React.Component));
export default Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Modal.js.map